(function () {
  'use strict';

  var FEATURE = 'ah_mdb_rollout_v1';
  var ROLLOUT_LABEL = 'full_mobile_rollout_2026_08_12';
  var ATTRIBUTION_KEY = 'ah-cro-' + FEATURE + '-attributed';
  var EXPOSURE_KEY = 'ah-cro-' + FEATURE + '-exposed';
  var WHATSAPP_FEATURE = 'ah_whatsapp_cart_help_v1';
  var WHATSAPP_ROLLOUT = 'full_cart_user_initiated_2026_08_14';
  var CHECKOUT_CLICK_KEY = 'ah-cro-checkout-clicked';
  var deliveryRates = {
    SU: ['6th of October', 65], SHR: ['Al Sharqia', 85], ALX: ['Alexandria', 75],
    AST: ['Asyut', 85], ASN: ['Aswan', 115], BH: ['Beheira', 85], BNS: ['Beni Suef', 85],
    C: ['Cairo', 65], DK: ['Dakahlia', 85], DT: ['Damietta', 85], FYM: ['Faiyum', 85],
    GH: ['Gharbia', 85], GZ: ['Giza', 65], HU: ['Helwan', 65], IS: ['Ismailia', 85],
    KFS: ['Kafr el-Sheikh', 85], LX: ['Luxor', 115], MT: ['Matrouh', 115],
    MNF: ['Monufia', 85], MN: ['Minya', 85], WAD: ['New Valley', 115], SIN: ['North Sinai', 115],
    PTS: ['Port Said', 85], KB: ['Qalyubia', 85], KN: ['Qena', 115], BA: ['Red Sea', 115],
    SHG: ['Sohag', 85], JS: ['South Sinai', 115], SUZ: ['Suez', 85]
  };
  var deliveryNamesAr = {
    SU: '6 أكتوبر', SHR: 'الشرقية', ALX: 'الإسكندرية', AST: 'أسيوط', ASN: 'أسوان',
    BH: 'البحيرة', BNS: 'بني سويف', C: 'القاهرة', DK: 'الدقهلية', DT: 'دمياط',
    FYM: 'الفيوم', GH: 'الغربية', GZ: 'الجيزة', HU: 'حلوان', IS: 'الإسماعيلية',
    KFS: 'كفر الشيخ', LX: 'الأقصر', MT: 'مطروح', MNF: 'المنوفية', MN: 'المنيا',
    WAD: 'الوادي الجديد', SIN: 'شمال سيناء', PTS: 'بورسعيد', KB: 'القليوبية',
    KN: 'قنا', BA: 'البحر الأحمر', SHG: 'سوهاج', JS: 'جنوب سيناء', SUZ: 'السويس'
  };

  function storageGet(storage, key) {
    try { return storage.getItem(key); } catch (error) { return null; }
  }

  function storageSet(storage, key, value) {
    try { storage.setItem(key, value); } catch (error) {}
  }

  function pushEvent(name, details) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name, feature_id: FEATURE }, details || {}));
  }

  function attributeCart(rolloutLabel) {
    if (storageGet(window.sessionStorage, ATTRIBUTION_KEY) === rolloutLabel) return;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { '_cro_mobile_decision_bar_v1': rolloutLabel } }),
      credentials: 'same-origin',
      keepalive: true
    }).then(function (response) {
      if (response.ok) storageSet(window.sessionStorage, ATTRIBUTION_KEY, rolloutLabel);
    }).catch(function () {});
  }

  function updateDeliveryCopy(root) {
    var code = storageGet(window.localStorage, 'arctic-hunter-delivery-governorate');
    var rate = code && deliveryRates[code];
    var isArabic = document.documentElement.lang.toLowerCase().indexOf('ar') === 0;

    root.querySelectorAll('[data-ah-delivery-summary]').forEach(function (element) {
      if (rate) {
        element.textContent = isArabic ? ('توصيل ' + rate[1] + ' ج.م · 2–5 أيام') : ('Delivery ' + rate[1] + ' EGP · 2–5 days');
      }
    });

    root.querySelectorAll('[data-ah-cart-delivery]').forEach(function (element) {
      if (rate) {
        var deliveryName = isArabic ? (deliveryNamesAr[code] || rate[0]) : rate[0];
        element.textContent = isArabic
          ? ('التوصيل إلى ' + deliveryName + ': ' + rate[1] + ' ج.م، والتكلفة النهائية عند الدفع')
          : ('Delivery to ' + deliveryName + ': ' + rate[1] + ' EGP; final fee at checkout');
      }
    });
  }

  function initCartConfidence() {
    updateDeliveryCopy(document);
    document.addEventListener('change', function (event) {
      if (!event.target.matches('[data-delivery-select]')) return;
      window.setTimeout(function () { updateDeliveryCopy(document); }, 0);
    });
    document.addEventListener('ajaxProduct:added', function () {
      window.setTimeout(function () { updateDeliveryCopy(document); }, 250);
    });
  }

  function initWhatsappCartHelp() {
    document.addEventListener('click', function (event) {
      if (event.target.closest('[type="submit"][name="checkout"]')) {
        storageSet(window.sessionStorage, CHECKOUT_CLICK_KEY, 'true');
        return;
      }

      var link = event.target.closest('[data-ah-whatsapp-help-link]');
      if (!link) return;
      var details = {
        event: 'whatsapp_help_click',
        feature_id: WHATSAPP_FEATURE,
        rollout: WHATSAPP_ROLLOUT,
        page_location: 'full_cart',
        cart_value: parseFloat(link.dataset.cartValue || '0'),
        cart_item_count: parseInt(link.dataset.cartItemCount || '0', 10),
        currency: link.dataset.cartCurrency || '',
        device_type: window.matchMedia('(max-width: 767px)').matches ? 'mobile' : 'desktop',
        language_variant: document.documentElement.lang.toLowerCase().indexOf('ar') === 0 ? 'ar' : 'en',
        session_had_checkout_click: storageGet(window.sessionStorage, CHECKOUT_CLICK_KEY) === 'true'
      };

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(details);

      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { '_cro_whatsapp_cart_help_v1': WHATSAPP_ROLLOUT } }),
        credentials: 'same-origin',
        keepalive: true
      }).catch(function () {});
    }, true);
  }

  function initStickyProductLocalization() {
    var stickyMedia = document.querySelector('[data-sticky-product-media][data-localized-product-title]');
    if (!stickyMedia) return;

    var stickyForm = stickyMedia.closest('product-sticky-form');
    var productForm = stickyForm && document.getElementById(stickyForm.getAttribute('form'));
    var stickyOptions = stickyForm && stickyForm.querySelector('[data-sticky-product-options]');
    var decisionBar = document.querySelector('[data-ah-decision-bar]');
    var localizedTitle = stickyMedia.dataset.localizedProductTitle;
    var variantLabels = {};
    try { variantLabels = JSON.parse((decisionBar && decisionBar.dataset.variantLabels) || '{}'); } catch (error) {}

    function updateContent(event) {
      var image = stickyMedia.querySelector('img');
      if (image) image.alt = localizedTitle;

      var variant = event && event.detail && event.detail.variant;
      if (variant && stickyOptions) stickyOptions.textContent = variantLabels[String(variant.id)] || variant.title || '';
    }

    updateContent();
    if (productForm) productForm.addEventListener('variant:change', updateContent);
  }

  function initDecisionBar(bar) {
    if (!window.matchMedia('(max-width: 767px)').matches) return;

    document.body.classList.add('ah-mdb-rollout');
    attributeCart(ROLLOUT_LABEL);
    pushEvent('ah_mdb_rollout_loaded', { rollout: ROLLOUT_LABEL, product_id: bar.dataset.productId });

    var form = document.getElementById(bar.dataset.formId);
    var nativeButton = form && form.querySelector('[type="submit"][name="add"]');
    var footer = document.querySelector('.footer-group');
    var button = bar.querySelector('[data-ah-mdb-submit]');
    var price = bar.querySelector('[data-ah-mdb-price]');
    var variantLabel = bar.querySelector('[data-ah-mdb-variant]');
    var variantLabels = {};
    try { variantLabels = JSON.parse(bar.dataset.variantLabels || '{}'); } catch (error) {}
    var buttonText = bar.querySelector('[data-ah-mdb-button-text]');
    var nativeButtonVisible = false;
    var footerVisible = false;
    var hasScrolled = window.scrollY > 72;

    bar.hidden = false;
    bar.dataset.active = 'true';

    function setVisibility() {
      var visible = hasScrolled && !nativeButtonVisible && !footerVisible;
      bar.dataset.visible = visible ? 'true' : 'false';
      document.body.classList.toggle('ah-mdb-visible', visible);
      if (visible && storageGet(window.sessionStorage, EXPOSURE_KEY) !== 'true') {
        storageSet(window.sessionStorage, EXPOSURE_KEY, 'true');
        pushEvent('ah_mdb_exposure', { rollout: ROLLOUT_LABEL, product_id: bar.dataset.productId });
      }
    }

    window.addEventListener('scroll', function () {
      hasScrolled = window.scrollY > 72;
      setVisibility();
    }, { passive: true });

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.target === nativeButton) nativeButtonVisible = entry.isIntersecting;
        if (entry.target === footer) footerVisible = entry.isIntersecting;
      });
      setVisibility();
    }, { threshold: 0.08 });
    if (nativeButton) observer.observe(nativeButton);
    if (footer) observer.observe(footer);

    if (button) {
      button.addEventListener('click', function () {
        pushEvent('ah_mdb_add_to_cart', {
          rollout: ROLLOUT_LABEL,
          product_id: bar.dataset.productId,
          product_title: bar.dataset.productTitle,
          variant_id: form && form.querySelector('[name="id"]') ? form.querySelector('[name="id"]').value : null
        });
      });
    }

    if (form) {
      form.addEventListener('variant:change', function (event) {
        var variant = event.detail && event.detail.variant;
        if (!variant) {
          button.disabled = true;
          return;
        }

        window.setTimeout(function () {
          var stickyPrice = document.querySelector('[id^="StickyPrice-"]');
          var sourcePrice = stickyPrice && (
            stickyPrice.querySelector('.price__regular, .price-item--sale')
            || stickyPrice.querySelector('.price__sale')
            || stickyPrice.querySelector('.price')
          );
          if (sourcePrice && price) price.textContent = sourcePrice.textContent.trim().replace(/\s+/g, ' ');
        }, 0);

        if (variantLabel) {
          variantLabel.textContent = variantLabels[String(variant.id)] || variant.title || '';
          variantLabel.hidden = !variant.title || variant.title === 'Default Title';
        }
        button.disabled = !variant.available;
        if (buttonText) buttonText.textContent = variant.available ? window.theme.variantStrings.addToCart : window.theme.variantStrings.soldOut;
      });
    }

    document.addEventListener('ajaxProduct:added', function () {
      attributeCart(ROLLOUT_LABEL);
    });
    setVisibility();
  }

  function init() {
    initCartConfidence();
    initWhatsappCartHelp();
    initStickyProductLocalization();
    var bar = document.querySelector('[data-ah-decision-bar]');
    if (bar) initDecisionBar(bar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
